import React, { Fragment, useState, useCallback, useMemo } from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import { Container, Row } from 'reactstrap';
import { Currency, WebApp, Spinner, FormControl, Directional, VideoPlayer, MedicalPlayer, TextEditor, BrandPlayer } from '../../../Constant';
import FontawesomeCommon from './FontawesomeCommon';
import IconMarkUp from '../Icon-markup';

const FontawesomeIcon = () => {
  const [iTag, setiTag] = useState('');
  const [icon, setIcon] = useState('');
  const data = useMemo(
    () => [
      {
        icons20: ['address-book', 'adjust', 'anchor', 'archive', 'area-chart'],
        currencyicons: ['usd', 'eur', 'btc', 'gbp'],
        webicons: ['chrome', 'edge', 'firefox', 'safari'],
        spinner: ['spinner', 'circle-o-notch'],
        formicons: ['check-square-o', 'minus-square-o', 'plus-square-o'],
        texteditoricons: ['align-center', 'bold', 'italic', 'underline'],
        directionalicons: ['arrow-up', 'arrow-down', 'arrow-left', 'arrow-right'],
        videoicons: ['video-camera', 'film', 'television'],
        branddicons: ['github', 'facebook', 'twitter', 'instagram'],
        medicalicons: ['ambulance', 'medkit', 'stethoscope'],
      },
    ],
    []
  );

  const callback = useCallback((tag) => {
    setiTag({
      iTag: '<i className="fa fa-' + tag + '"></i>',
    });
    setIcon({
      icon: 'fa fa-' + tag + ' fa-2x',
    });
  }, []);
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Fontawesome Icons' parent='Icons' title='Fontawesome Icons' />
      <Container fluid={true}>
        {data.map((icons, index) => {
          return (
            <Row key={index}>
              <FontawesomeCommon iconType={icons.icons20} title='20' parentCallback={callback} />
              <FontawesomeCommon iconType={icons.currencyicons} title={Currency} parentCallback={callback} />
              <FontawesomeCommon iconType={icons.webicons} title={WebApp} parentCallback={callback} />
              <FontawesomeCommon iconType={icons.spinner} title={Spinner} parentCallback={callback} />
              <FontawesomeCommon iconType={icons.formicons} title={FormControl} parentCallback={callback} />
              <FontawesomeCommon iconType={icons.texteditoricons} title={TextEditor} parentCallback={callback} />
              <FontawesomeCommon iconType={icons.directionalicons} title={Directional} parentCallback={callback} />
              <FontawesomeCommon iconType={icons.videoicons} title={VideoPlayer} parentCallback={callback} />
              <FontawesomeCommon iconType={icons.branddicons} title={BrandPlayer} parentCallback={callback} />
              <FontawesomeCommon iconType={icons.medicalicons} title={MedicalPlayer} parentCallback={callback} />
            </Row>
          );
        })}
      </Container>
      <IconMarkUp itag={iTag} icons={icon} />
    </Fragment>
  );
};

export default FontawesomeIcon;
